import styled from '@emotion/styled';
import { colors, getSpacing } from '@cabonline/ui-shared';

export const StyledRadioButtonLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${getSpacing('xxs')};
  cursor: pointer;
  position: relative;

  &:has(input:disabled) {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const HiddenRadioButton = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + span:after {
    opacity: 1;
  }
  &:disabled + span {
    border-color: ${colors.gray2};
    cursor: not-allowed;
  }
  &:disabled + span:after {
    background-color: ${colors.gray2};
  }
  &:hover:not(:disabled) + span:before {
    opacity: 1;
  }
  &:focus + span {
    background-color: ${colors.gray3};
    box-shadow: 0 0 0 6px ${colors.gray3};
  }
`;

export const StyledRadioButton = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid ${colors.black};
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  &:after {
    content: '';
    width: 12px;
    height: 12px;
    background-color: ${colors.black};
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  &:before {
    content: '';
    width: 32px;
    height: 32px;
    background-color: ${colors.gray4};
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    z-index: -1;
  }
`;

export const StyledRadioButtonLabelChecked = styled(StyledRadioButton)`
  &:after {
    opacity: 1;
  }
`;
